module.exports = __webpack_public_path__ + "img/beau-1.eea5f85c.png";